import React, { useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import { Header } from 'src/features';

import './layout.scss';

export const Layout = (props) => {
  const { children } = props;

  const { pathname } = useLocation();

  useEffect(() => {
    const canControlScrollRestoration = 'scrollRestoration' in window.history;

    if (canControlScrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="layout">
      <Header />
      <div>{children ?? <Outlet />}</div>

      <div className="landing-footer__divider">
        <div className="landing-footer__bottom">
          <span>© {new Date().getFullYear()} RulesEngineBot. All rights reserved.</span>
          <div className="landing-footer__policies">
            <Link className="landing-footer__policy-link" to="/terms">
              Terms
            </Link>
            <Link className="landing-footer__policy-link" to="/privacy">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
